<form class="combobox-block">
    <select required [formControl]="dropDownControl">
        <option *ngFor="let displayValue of displayValues" [value]="displayValue.ValeurID">{{displayValue.Valeur}}</option>
    </select>
</form>
<span *ngIf="displayRequiedError" class="requied-error-message select-list-custom">Champ obligatoire</span>

